export const NOTICE_PERIOD_OPTIONS = [
    {
        name: 'Off',
        value: 0
    },
    {
        name: '30 minutes',
        value: 30
    },
    {
        name: '60 minutes',
        value: 60
    },
    {
        name: '90 minutes',
        value: 90
    },
    {
        name: '2 hours',
        value: 120
    },
    {
        name: '3 hours',
        value: 180
    },
    {
        name: '4 hours',
        value: 240
    },
    {
        name: '1 day',
        value: 1440
    },
    {
        name: '2 days',
        value: 2880
    },
    {
        name: '3 days',
        value: 4320
    },
    {
        name: '1 week',
        value: 10080
    }
];
